import * as MutationTypes from "../mutation_types"
import { State, User } from "../store_types"
import { callSignInApi, callSignOutApi, callValidateTokenApi } from "../../api/auth"
import { AxiosResponseHeaders } from "axios"

const getDefaultState  = () => {
  return {
    currentUser : null,
    authHeaders : {
      "access-token": "",
      "token-type": "",
      client: "",
      expiry: "",
      uid: "",
      authorization: ""
    }
  }
}

const currentUser = {
  state: () => getDefaultState(),

  getters: {
    currentUser (state : State) {
      return state.currentUser
    },
    authHeaders (state : State) {
      return state.authHeaders
    },
  },

  actions: {
    signIn({ dispatch, commit }: { dispatch: (actionName: string) => void, commit: (mutationType:string, resultData: AxiosResponseHeaders | User) => void }, params: { email:string, password:string }){
      // store情報のクリア
      dispatch("resetState")
      return new Promise<void>((resolve, reject) => {
        // ログイン処理
        callSignInApi(
          params,
          // Success
          (headers: AxiosResponseHeaders, currentUser: User) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_CURRENT_USER, currentUser)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    signOut({ dispatch, commit, state }: { dispatch: (actionName: string) => void, commit: (mutationType:string, resultData: AxiosResponseHeaders) => void, state: State }){
      return new Promise<void>((resolve, reject) => {
        // サインアウト
        callSignOutApi(
          state.authHeaders,
          // Success
          (headers: AxiosResponseHeaders, result: boolean) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            if(result){
              dispatch("resetState")
              resolve()
            } else {
              reject()
            }
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    validateToken({ commit, state }: { commit: (mutationType:string, resultData: AxiosResponseHeaders) => void , state: State }){
      return new Promise<void>((resolve, reject) => {
        // tokenの整合性チェック
        callValidateTokenApi(
          state.authHeaders,
          // Success
          (headers: AxiosResponseHeaders, result: boolean) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            if(result){
              resolve()
            } else {
              reject()
            }
          },
          // Failure
          () => {
            reject()
          })
      })
    },

    resetCurrentUserState ({ commit }: { commit: (mutationType:string) => void }) {
      commit(MutationTypes.RESET_CURRENT_USER_STATE)
    },
    resetState({ dispatch }: {dispatch: (actionName: string) => void }) {
      dispatch("resetAfterUseQuestionnairePublicAvailabilitiesState")
      dispatch("resetAfterUseQuestionnairesState")
      dispatch("resetComplaintPublicAvailabilitiesState")
      dispatch("resetComplaintsState")
      dispatch("resetCorporationsState")
      dispatch("resetCurrentUserState")
      dispatch("resetManagersState")
      dispatch("resetMedicalInformationsState")
      dispatch("resetMontylyReportMailsState")
      dispatch("resetQuestionnaireCountState")
      dispatch("resetSelectedValuesState")
      dispatch("resetReseponseResultsState")
      dispatch("resetCorporationsState")
    },
  },

  mutations: {
    [MutationTypes.ASSIGN_CURRENT_USER](state: State, currentUser: User) {
      state.currentUser = currentUser
    },
    [MutationTypes.ASSIGN_AUTH_HEADERS](state: State, headers: AxiosResponseHeaders) {
      if(headers["access-token"]){
        state.authHeaders = {
          "access-token": headers["access-token"],
          "token-type": headers["token-type"],
          client: headers["client"],
          expiry: headers["expiry"],
          uid: headers["uid"],
          authorization: headers["authorization"],
        }
      }
    },
    [MutationTypes.RESET_CURRENT_USER_STATE](state: State) {
      Object.assign(state, getDefaultState())
    },
  },
}

export default currentUser
